import {
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST,
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS,
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE,
} from "./actionType";

// Get SINGLE JOB PAGE Invoice Items List
export const getSingleJobPageInvoiceItemsList = (jobId) => {
  return {
    type: GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST,
    payload: jobId,
  };
};

export const getSingleJobPageInvoiceItemsListSuccess = (data) => {
  return {
    type: GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS,
    payload: data,
  };
};

export const getSingleJobPageInvoiceItemsListFailure = (error) => {
  return {
    type: GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE,
    payload: error,
  };
};
